<div class="label-header">
  <label>{{ data?.data?.label}}</label>
</div>

<cs-gauge [dataSource]="data"></cs-gauge>
